import { ResponseDataObject } from '@jobindsats/typescript-fetch-jobindsats';
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

@customElement('maaling-calculate-element')
export class MaalingCalculateElement extends LitElement {

    static styles = css`
        .container {
            display: flex;
            flex-direction: column;
        }
        ul {
            padding: 0px 0 5px 0;
            margin: 5px 0 0 0;
            width: 100%;
            position: relative;
        }
        li {
            display: block;
            border: 1px solid #b5b5b5;
            background: #dedede;
            font-size: 14px;
            color: #333;
            border-radius: 3px;
            padding: 8px 32px 8px 12px;
            margin: 8px 11px 8px 11px;
            cursor: pointer;
        }
        li:hover {
            background: #C3CFFE;
        }
        .calc-button {
            background-color: var(--main-blue);
            color: white;
            border: none;
            padding: 10px;
            font-weight: bold;
            margin-top: 10px;
            cursor: pointer;
        }
        .name-input {
            margin-top: 10px;
            border: none;
            outline: solid;
            outline-width: 3px;
            outline-color: var(--main-blue-10);
            height: 35px;
            padding-left: 10px;
        }
        .name-input:focus {
            outline-color: var(--main-blue-50);
        }
        .calc-buttons-container {
            display: flex;
            gap: 5px;
            flex-wrap: wrap;
        }
        .calc-method-button {
            padding: 10px 15px;
            background: transparent;
            border: 2px solid var(--main-blue);
            color: var(--main-blue);
            font: inherit;
            font-weight: bold;
        }
        .calc-method-button:hover {
            border-color: var(--main-blue-25);
        }
        .button-selected {
            background-color: var(--main-blue-10);
        }
        .title {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 15px;
        }
        .red-star {
            color: red;
        }
        .name-calculation {
            margin-top: 15px;
        }
        .outcome-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .select-box {
            border: none;
            outline: solid;
            outline-width: 3px;
            outline-color: var(--main-blue-10);
            border-radius: 0px;
            font-family: inherit;
            background-color: white;
            min-height: 35px;
            margin-bottom: 10px; 
            scrollbar-width: thin;
            scrollbar-color: var(--thumbBG) var(--scrollbarBG);
        }
        .select-box:focus {
            outline-color: var(--main-blue-50);
        }
        .pct-cbox {
            margin-top: 10px;
        }
        .name-error-false {
            display: none;
        }
        .name-error-true {
            display: block;
            color: var(--main-red);
            font-family: inherit;
            font-size: 14px;
            margin-top: 10px;
        }
        .selection-error-true {
            display: block;
            color: var(--main-red);
            font-family: inherit;
            font-size: 14px;
            margin-top: 10px;
        }
        .selection-error-false {
            display: none;
        }
        select.select-box::-webkit-scrollbar {
            width: 13px;
        }
        select.scrollbar-style::-webkit-scrollbar-track {
            background: var(--scrollbarBG);
        }
        select.scrollbar-style::-webkit-scrollbar-thumb {
            background-color: var(--thumbBG);
            border-radius: 6px;
        }
        @media only screen and (min-width: 992px) {
            .container {
                margin-bottom: 10px;
                justify-content: space-between;
                max-width: 500px;
                width: 100%;
            }
        }
        @media only screen and (max-width: 991px) {
            .select-box {
                padding-left: 15px;
            }
        }
    `;

    @property({ type: Array })
    rows: string[] = [];

    @property({ type: Array })
    columns: string[] = [];

    @property({
        type: Map,
    })
    relatedDimensions: Map<string, string[]> = new Map();

    @property()
    headerArray?: string[][] = [];

    @property()
    dataString?: any;

    @property({ type: String })
    jsonData?: string;

    @property()
    indexArray?: string[];

    @property()
    dimensionSort: Map<string, string[]> = new Map();

    @property()
    periodDisplaynameAndSort: Map<string, string> = new Map();

    @state()
    allowedDiffers: string[] = [];

    @state()
    includeDiscretionaryValues: boolean = true;

    @state()
    dataObject?: any;

    @state()
    dimensions?: string[];

    @state()
    outcomes?: string[];

    @state()
    sumSelected?: boolean = true;

    @state()
    avgSelected?: boolean = false;

    @state()
    difSelected?: boolean = false;

    @state()
    pctSelected?: boolean = false;

    @state()
    resultInPercent?: boolean = false;

    @state()
    selectedDimension?: string;

    @state()
    selectionIndex?: number;

    @state()
    dimIdx: number = -1;

    @state()
    nameExistsError = false;

    @state()
    nameMissingError = false;

    @state()
    selectionLengthError = false;

    resultName: string = "";

    willUpdate(changedProperties: Map<string, any>) {

        // Remove unwanted variables
        if (changedProperties.has('columns') || changedProperties.has('rows')) {
            this.relatedDimensions.forEach((value, key) => {
                if (this.rows.includes(key)) {
                    this.rows = this.rows.filter(a => !value.includes(a));
                }
                else if (this.columns.includes(key)) {
                    this.columns = this.columns.filter(a => !value.includes(a));
                }
            });
            this.dimensions = this.rows.concat(this.columns);

            // Remove Målinger
            if (this.dimensions.includes("Målingsvariable")) {
                const index = this.dimensions.indexOf("Målingsvariable", 0);
                if (index > -1) {
                    this.dimensions.splice(index, 1);
                }
            }
        }
    }

    connectedCallback() {
        super.connectedCallback();
        this.dataObject = JSON.parse(this.dataString);
        this.selectedDimension = "Periode";
        this.handleDimensionSelection(this.selectedDimension);
    }


    render() {
        return html`
            <section class="container">
                <div class="title">Lommeregner</div>
                <div>Med lommeregneren kan du beregne summer, simple gennemsnit, forskelle og andele. Vær opmærksom på, at det er muligt at skabe fejlagtige resultater afhængig af hvilken beregning, fordelingsvariabel og udfaldsrum, som du vælger. Dertil kan resultaterne være upræcise på grund af diskretionering.</div>
                <p><strong>Vælg beregning </strong></p>
                    <div class="calc-buttons-container">
                        <input class="calc-method-button ${this.sumSelected ? 'button-selected' : ''}" type="button" id="rSum" name="calcMethod" value="Sum" @click=${() => this.handleSumSelected()}>
                        <input class="calc-method-button ${this.avgSelected ? 'button-selected' : ''}" type="button" id="rAvg" name="calcMethod" value="Gennemsnit" @click=${() => this.handleAvgSelected()}>
                        <input class="calc-method-button ${this.difSelected ? 'button-selected' : ''}" type="button" id="rDif" name="calcMethod" value="Forskel" @click=${() => this.handleDifSelected()}>
                        <input class="calc-method-button ${this.pctSelected ? 'button-selected' : ''}" type="button" id="rPct" name="calcMethod" value="Andel" @click=${() => this.handlePctSelected()}>
                    </div>
                <p><strong>Vælg fordelingsvariabel </strong></p>
                    <div class="calc-buttons-container">
                        ${this.dimensions?.map((dim) => html`
                            <input class="calc-method-button ${dim === this.selectedDimension ? 'button-selected' : ''}" type="button" value="${dim}" @click=${(ev: MouseEvent) => { this.handleDimensionSelection(dim); }}>
                        `)}
                    </div>
                    <div class="name-calculation"><strong>Navngiv beregningen<span class="red-star">*</span> <span class="${this.nameExistsError ? 'name-error-true' : 'name-error-false'}">Navnet findes i forvejen</span> <span class="${this.nameMissingError ? 'name-error-true' : 'name-error-false'}">Angiv et navn til beregningen</span></strong></div>
                    <input aria-label="Navngivning" class="name-input" type="text" id="resultName" name="resultName">

                    ${this.sumSelected ? html`
                        <div class="outcome-title">
                            <p><strong>Vælg de udfaldsrum, der skal summeres<span class="red-star">*</span> <span class="${this.selectionLengthError ? 'selection-error-true' : 'selection-error-false'}">Vælg mindst to udfaldsrum</span> </strong></p>
                            <span title="Værktøjstip:&#10;Hold CTRL (Windows) eller Command (Mac) nede for at vælge flere udfaldsrum.&#10;Du kan også vælge flere udfaldsrum ved at holde og trække musen over udfaldsrum.&#10;Brug CTRL + A for at vælge alle udfaldsrum.">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.0001 7.00006H9.00006V5.00006H11.0001V7.00006ZM11.0001 15.0001L9.00006 15.0001V9.00006H11.0001V15.0001ZM10.0101 20.0001C15.5301 20.0001 20.0001 15.5201 20.0001 10.0001C20.0001 4.48006 15.5301 6.58035e-05 10.0101 6.58035e-05C4.48006 6.58035e-05 6.58035e-05 4.48006 6.58035e-05 10.0001C6.58035e-05 15.5201 4.48006 20.0001 10.0101 20.0001ZM10.0001 2.00007C14.4201 2.00007 18.0001 5.58006 18.0001 10.0001C18.0001 14.4201 14.4201 18.0001 10.0001 18.0001C5.58006 18.0001 2.00007 14.4201 2.00007 10.0001C2.00007 5.58006 5.58006 2.00007 10.0001 2.00007Z" fill="var(--main-blue-25)"/>
                                </svg>
                            </span>
                        </div>
                        <select aria-label="Udfaldsrum" class="select-box scrollbar-style" id="sumList" Name="Liste" Size="10" multiple>
                            ${this.outcomes?.map((outcome) => html`
                                <option>${outcome}</option>
                            `)}
                        </select>
                    ` : ''}
                    ${this.avgSelected ? html`
                        <div class="outcome-title">
                            <p><strong>Vælg de udfaldsrum, der skal beregnes gennemsnit af<span class="red-star">*</span> <span class="${this.selectionLengthError ? 'selection-error-true' : 'selection-error-false'}">Vælg mindst to udfaldsrum</span> </strong></p>
                            <span title="Hold CTRL (Windows) eller Command (Mac) nede for at vælge flere.&#10;Du kan også holde og trække musen over udfaldsrum.&#10;Brug CTRL + A for at vælge alle.">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.0001 7.00006H9.00006V5.00006H11.0001V7.00006ZM11.0001 15.0001L9.00006 15.0001V9.00006H11.0001V15.0001ZM10.0101 20.0001C15.5301 20.0001 20.0001 15.5201 20.0001 10.0001C20.0001 4.48006 15.5301 6.58035e-05 10.0101 6.58035e-05C4.48006 6.58035e-05 6.58035e-05 4.48006 6.58035e-05 10.0001C6.58035e-05 15.5201 4.48006 20.0001 10.0101 20.0001ZM10.0001 2.00007C14.4201 2.00007 18.0001 5.58006 18.0001 10.0001C18.0001 14.4201 14.4201 18.0001 10.0001 18.0001C5.58006 18.0001 2.00007 14.4201 2.00007 10.0001C2.00007 5.58006 5.58006 2.00007 10.0001 2.00007Z" fill="var(--main-blue-25)"/>
                                </svg>
                            </span>
                        </div>

                        <select aria-label="Udfaldsrum" class="select-box scrollbar-style" id="avgList" Name="Liste" Size="10" multiple>
                            ${this.outcomes?.map((outcome) => html`
                                <option>${outcome}</option>
                            `)}
                        </select>

                    ` : ''}
                    ${this.difSelected ? html`
                        <p><strong>Vælg to udfaldsrum til beregning af forskel<span class="red-star">*</span> <span class="${this.selectionLengthError ? 'selection-error-true' : 'selection-error-false'}">Vælg mindst to udfaldsrum</span> </strong></p>

                        <select aria-label="Udfaldsrum" class="select-box scrollbar-style" id="difList1" Name="Liste" Size="7">
                            ${this.outcomes?.map((outcome) => html`
                                <option>${outcome}</option>
                            `)}
                        </select>

                        <p><strong> 👆 minus 👇 </strong></p>

                        <select aria-label="Udfaldsrum" class="select-box scrollbar-style" id="difList2" Name="Liste" Size="7">
                            ${this.outcomes?.map((outcome) => html`
                                <option>${outcome}</option>
                            `)}
                        </select>

                    ` : ''}
                    ${this.pctSelected ? html`
                        <p><strong>Vælg to udfaldsrum til beregning af andel<span class="red-star">*</span> <span class="${this.selectionLengthError ? 'selection-error-true' : 'selection-error-false'}">Vælg mindst to udfaldsrum</span> </strong></p>

                        <select aria-label="Udfaldsrum" class="select-box scrollbar-style" id="pctList1" Name="Liste" Size="7">
                            ${this.outcomes?.map((outcome) => html`
                                <option>${outcome}</option>
                            `)}
                        </select>

                        <p><strong> 👆 delt med 👇 </strong></p>

                        <select aria-label="Udfaldsrum" class="select-box scrollbar-style" id="pctList2" Name="Liste" Size="7">
                            ${this.outcomes?.map((outcome) => html`
                                <option>${outcome}</option>
                            `)}
                        </select>

                        <div>
                            <input class="pct-cbox" type="checkbox" id="pctCheckbox" name="cbox" value="pctCheck" .checked="${this.resultInPercent}" @click=${() => this.handleResultInPctSelected()}>
                            <label for="pctCheckbox">Opgør resultatet i procent</label><br>
                        </div>
                    ` : ''}

                    <button class="calc-button" id="calcBtn" @click=${() => { this.handleCalcButtonClicked(); }}>
                        <div>Beregn</div>
                    </button>

            </section>
        `;
    }

    handleDimensionSelection(dim: string) {
        this.selectedDimension = dim;
        this.outcomes = this.retrieveOutcomes(dim);
    }

    retrieveOutcomes(dim: string) {
        var outcomes: string[] = [];
        this.allowedDiffers = [];

        // Finding the dimension code name
        var idx = -1;
        if (this.headerArray) {
            const headerNames = this.headerArray[1];
            const headerCodes = this.headerArray[0];
            for (var i = 0; i < headerNames.length; i++) {
                let name = headerNames[i];
                if (dim === name) {
                    idx = headerCodes.indexOf(headerCodes[i]);
                    this.dimIdx = idx;
                    break;
                }
            }

            // Finding the index of the dimension
            for (var i = 0; i < headerCodes.length; i++) {
                let name = headerNames[i];
                if (dim === name) {
                    if (dim === 'Periode') {
                        this.selectionIndex = 0;
                        break;
                    }
                    else if (dim === 'Område') {
                        this.selectionIndex = this.indexArray?.indexOf('Område');
                        break;
                    }
                    else {
                        this.selectionIndex = this.indexArray?.indexOf(headerCodes[i]);
                    }
                }
            }

            // Make list of codes for selected dimension
            headerNames.forEach((name, key) => {
                if (name === 'Område' && dim === 'Område') {
                    this.allowedDiffers.push('Område');
                }
                else if (name === dim) {
                    this.allowedDiffers.push(headerCodes[key]);
                }
            });
            this.allowedDiffers.push('Målingsværdi');
        }

        // Finding the outcome names in data
        if (idx != -1) {
            const data = this.dataObject;
            if (data) {
                for (var i = 0; i < data.length; i++) {
                    if (!outcomes.includes(data[i][idx])) {
                        outcomes.push(data[i][idx]);
                    }
                }
            }
        }

        // Map the correct period names
        if (dim === "Periode") {
            outcomes.forEach((outcome, key) => {
                if (this.periodDisplaynameAndSort?.has(outcome)) {
                    let name = this.periodDisplaynameAndSort.get(outcome);
                    if (name) {
                        outcomes[key] = name;
                    }
                }
            });
        }

        outcomes = this.sortOutcomes(outcomes, dim, idx);

        return outcomes;
    }

    sortOutcomes(outcomes: string[], dim: string, dimIdx: number) {
        var sortedOutcomes: string[] = [];

        if (this.headerArray) {

            if (dim !== 'Område' && dim !== 'Periode') {
                var dimCode: string = this.headerArray[0][dimIdx];

                this.dimensionSort.forEach((value, key) => {
                    if (key === dimCode || key === dimCode.substring(1)) {
                        sortedOutcomes = value;
                    }
                });
            }
            else if (dim === 'Område') {
                this.dimensionSort.forEach((value, key) => {
                    if (key === dim) {
                        sortedOutcomes = value;
                    }
                });
            }
            else if (dim === 'Periode') {
                this.periodDisplaynameAndSort.forEach((value) => {
                    sortedOutcomes.push(value);
                });
            }
        }

        if (sortedOutcomes.length > 0) {
            return sortedOutcomes;
        }
        else {
            return outcomes;
        }

    }

    async handleCalcButtonClicked() {
        var selections: string[] = [];

        if (this.sumSelected) {
            selections = this.extractSelectedOutcomesSumAvg('sumList');
        }
        else if (this.avgSelected) {
            selections = this.extractSelectedOutcomesSumAvg('avgList');
        }
        else if (this.difSelected) {
            selections = this.extractSelectedOutcomesDifPct('difList1', 'difList2');
        }
        else if (this.pctSelected) {
            selections = this.extractSelectedOutcomesDifPct('pctList1', 'pctList2');
        }

        if (this.inputValidation(selections)) {
            this.addToSorters(selections);
            await this.addResultToJSON(selections);
        }
    }

    inputValidation(selections: string[]) {
        var inputfield = this.shadowRoot?.getElementById('resultName') as HTMLInputElement;

        var listboxList: HTMLSelectElement[] = [];
        listboxList.push(this.shadowRoot?.getElementById('sumList') as HTMLSelectElement,
            this.shadowRoot?.getElementById('avgList') as HTMLSelectElement,
            this.shadowRoot?.getElementById('difList1') as HTMLSelectElement,
            this.shadowRoot?.getElementById('difList2') as HTMLSelectElement,
            this.shadowRoot?.getElementById('pctList1') as HTMLSelectElement,
            this.shadowRoot?.getElementById('pctList2') as HTMLSelectElement);

        const inputName = inputfield.value;
        this.resultName = inputName;

        if (this.pctSelected && this.resultInPercent) {
            this.resultName = inputName + ' (%)';
        }

        if (this.outcomes?.includes(inputName)) {
            this.nameExistsError = true;
            this.nameMissingError = false;
            inputfield.style.outlineColor = 'var(--main-red)';
            inputfield.style.outlineWidth = '1px';
            return false;
        }

        if (!inputName) {
            this.nameMissingError = true;
            this.nameExistsError = false;
            inputfield.style.outlineColor = 'var(--main-red)';
            inputfield.style.outlineWidth = '1px';
            return false;
        }

        selections = selections.filter((selection) => {
            return selection !== undefined;
        });

        listboxList = listboxList.filter((box) => {
            return box !== null;
        });

        if (selections.length < 2) {
            this.selectionLengthError = true;
            listboxList.forEach((box) => {
                if ((box.multiple && box.selectedOptions.length < 2) || (!box.multiple && box.selectedOptions.length < 1)) {
                    box.style.outlineColor = 'var(--main-red)';
                    box.style.outlineWidth = '1px';
                }
            });
            return false;
        }

        return true;
    }

    addToSorters(selections: string[]) {
        var lastSelection = selections[selections.length - 1];
        var selectionIdx = 0;

        selections.forEach((selection) => {
            if (this.outcomes?.indexOf(selection) && this.outcomes?.indexOf(selection) > selectionIdx) {
                lastSelection = selection;
                selectionIdx = this.outcomes?.indexOf(selection);
            }
        });

        if (this.headerArray) {

            if (this.selectedDimension !== 'Område' && this.selectedDimension !== 'Periode') {
                var dimCode: string = this.headerArray[0][this.dimIdx];

                this.dimensionSort.forEach((value, key) => {
                    if (key === dimCode || key === dimCode.substring(1)) {
                        value.splice(value.indexOf(lastSelection) + 1, 0, this.resultName);
                    }
                });
            }

            else if (this.selectedDimension === 'Område') {
                this.dimensionSort.forEach((value, key) => {
                    if (key === this.selectedDimension) {
                        value.splice(value.indexOf(lastSelection) + 1, 0, this.resultName);
                    }
                });
            }

            else if (this.selectedDimension === 'Periode') {
                var arr = Array.from(this.periodDisplaynameAndSort);

                arr.forEach((value, idx) => {
                    if (value[1] === lastSelection) {
                        arr.splice(idx + 1, 0, [this.resultName, this.resultName]);
                    }
                });

                this.periodDisplaynameAndSort = new Map(arr);
            }
        }
    }

    addResultToJSON(selections: string[]) {
        if (this.jsonData && this.selectionIndex !== undefined && this.indexArray) {
            var dataIndex = this.indexArray.indexOf('Målingsværdi');
            var json = JSON.parse(this.jsonData);
            var indicesThatDiffer: Number[] = [];

            // Find indices in data array, relating outcomes and dimensions
            for (var i = 0; i < this.allowedDiffers.length; i++) {
                if (this.indexArray.includes(this.allowedDiffers[i]) || this.selectionIndex === 0) {
                    indicesThatDiffer.push(this.indexArray.indexOf(this.allowedDiffers[i]));
                    if (this.selectionIndex === 0) {
                        indicesThatDiffer.push(0);
                    }
                }
            }

            var jsonToCombine = new Array(); // Selected data
            var jsonToAppend = new Array(); // Calculation result
            var validatorArray = new Array(); // Header values to validate which entries correspond


            // Construct array in which calculations are performed
            for (let i = 0; i < selections.length; i++) {

                for (let entry of json) {
                    if (entry[this.selectionIndex].trim() === selections[i] && entry[dataIndex] !== '.') {
                        if (i === 0) {
                            var included = false;
                            for (var j = 0; j < jsonToCombine.length; j++) {
                                if (this.arraysEqual(jsonToCombine[j][0], entry)) {
                                    included = true;
                                }
                            }
                            if (!included) {
                                jsonToCombine.push([entry]);
                            }

                            // Remove indicesThatDiffer and add remaining array to the validator array
                            var entryDiffers = new Array();
                            for (var j = 0; j < entry.length; j++) {
                                if (!indicesThatDiffer.includes(j)) {
                                    entryDiffers.push(entry[j]);
                                }
                            }

                            included = false;
                            for (var j = 0; j < validatorArray.length; j++) {
                                if (this.arraysEqual(validatorArray[j], entryDiffers)) {
                                    included = true;
                                }
                            }
                            if (!included) {
                                validatorArray.push(entryDiffers);
                            }
                        }
                        else {
                            var entryDiffers = new Array();
                            for (var j = 0; j < entry.length; j++) {
                                if (!indicesThatDiffer.includes(j)) {
                                    entryDiffers.push(entry[j]);
                                }
                            }


                            var idxx = -1;
                            for (var j = 0; j < validatorArray.length; j++) {
                                if (this.arraysEqual(validatorArray[j], entryDiffers)) {
                                    idxx = j; // Putting value at this index in jsonToCombine
                                }
                            }

                            // Check if this entry corresponds with a previous one
                            if (idxx !== -1) {
                                var included = false;
                                for (var j = 0; j < jsonToCombine[idxx].length; j++) {
                                    if (this.arraysEqual(jsonToCombine[idxx][j], entry)) {
                                        included = true;
                                    }
                                }
                                if (!included) {
                                    jsonToCombine[idxx].push(entry);
                                }
                            }
                            else { // If not, append it to both arrays
                                jsonToCombine.push([entry]);
                                validatorArray.push(entryDiffers);
                            }
                        }
                    }
                }
            }

            // Perform calculations
            for (let entry of jsonToCombine) {

                // Check for nulls 
                for (let obj of entry) {
                    if (!obj[dataIndex]) {
                        entry.splice(entry.indexOf(obj), 1);
                    }
                }

                var idx = 0;
                var resultObj: any[] = [];
                for (let obj of entry) {
                    if (obj[dataIndex]) {

                        var thisObj = [...obj];

                        for (let i = 0; i < thisObj.length; i++) {
                            if (i === dataIndex) {
                                thisObj[i] = Number(thisObj[i].replaceAll(".", "").replaceAll(",", "."));
                            }

                            if (idx === 0) {
                                resultObj.push(thisObj[i]);

                                if (indicesThatDiffer.includes(i) && i !== dataIndex && this.includeDiscretionaryValues) {
                                    resultObj[i] = this.resultName;
                                }
                            }
                            else {
                                if (i === dataIndex) {
                                    if (this.sumSelected || this.avgSelected) {
                                        resultObj[i] += thisObj[i];
                                    } else if (this.difSelected) {
                                        resultObj[i] = resultObj[i] - thisObj[i];
                                    } else if (this.pctSelected) {
                                        if (thisObj[i] !== 0) {
                                            resultObj[i] = Number(resultObj[i] / thisObj[i]);
                                            if (this.resultInPercent) {
                                                resultObj[i] = resultObj[i] * 100;
                                            }
                                            resultObj[i] = Number(resultObj[i].toFixed(2));
                                        }
                                        else {
                                            resultObj[i] = 'Fejl. Division med 0';
                                        }
                                    }
                                }
                                else if (resultObj[i] !== thisObj[i]) {
                                    resultObj[i] = this.resultName;
                                }
                            }
                        }
                        idx++;
                    }
                }


                if (entry.length > 0 && resultObj[dataIndex] !== null && resultObj[dataIndex] !== undefined) {
                    if (this.avgSelected) {
                        resultObj[dataIndex] = Number((resultObj[dataIndex] / entry.length).toFixed(2));
                    }

                    resultObj[dataIndex] = resultObj[dataIndex].toLocaleString('da-DK');

                    jsonToAppend.push(resultObj);
                }
            }

            for (let entry of jsonToAppend) {
                json.push(entry);
            }

            json.unshift(this.indexArray);
            this.emitCalculationDoneEvent(json);
        }
    }

    emitCalculationDoneEvent(data: any[]) {
        const calcDoneEvent = new CustomEvent('calc-done', {
            detail: {
                json: data,
                periodSort: this.periodDisplaynameAndSort,
                dimensionSort: this.dimensionSort
            },
            composed: true,
            bubbles: true,
        });
        this.dispatchEvent(calcDoneEvent);
    }

    extractSelectedOutcomesSumAvg(id: string) {
        var listbox = this.shadowRoot?.getElementById(id) as HTMLSelectElement;
        var selectedOutcomes = [];
        var options = listbox && listbox.options;
        var opt;

        for (var i = 0, iLen = options.length; i < iLen; i++) {
            opt = options[i];
            if (opt.selected) {
                selectedOutcomes.push(opt.value || opt.text);
            }
        }

        return selectedOutcomes;
    }

    extractSelectedOutcomesDifPct(id1: string, id2: string) {
        var listbox1 = this.shadowRoot?.getElementById(id1) as HTMLSelectElement;
        var selectedOutcomesLB1 = [];
        var options = listbox1 && listbox1.options;
        var opt;

        for (var i = 0, iLen = options.length; i < iLen; i++) {
            opt = options[i];
            if (opt.selected) {
                selectedOutcomesLB1.push(opt.value || opt.text);
            }
        }

        var listbox2 = this.shadowRoot?.getElementById(id2) as HTMLSelectElement;
        var selectedOutcomesLB2 = [];
        var options = listbox2 && listbox2.options;
        var opt;

        for (var i = 0, iLen = options.length; i < iLen; i++) {
            opt = options[i];

            if (opt.selected) {
                selectedOutcomesLB2.push(opt.value || opt.text);
            }
        }

        var result = [selectedOutcomesLB1[0], selectedOutcomesLB2[0]];

        return result;
    }

    handleSumSelected() {
        this.allButtonsFalse();
        this.sumSelected = true;
    }

    handleAvgSelected() {
        this.allButtonsFalse();
        this.avgSelected = true;
    }

    handleDifSelected() {
        this.allButtonsFalse();
        this.difSelected = true;
    }

    handlePctSelected() {
        this.allButtonsFalse();
        this.pctSelected = true;
    }

    handleResultInPctSelected() {
        this.resultInPercent = !this.resultInPercent;
    }

    allButtonsFalse() {
        this.sumSelected = false;
        this.avgSelected = false;
        this.difSelected = false;
        this.pctSelected = false;
    }

    arraysEqual(a: any[], b: any[]) {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length !== b.length) return false;

        for (var i = 0; i < a.length; ++i) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
}